import React from 'react';
import Intro from './Intro';
import Perfection from './Perfection';
import SwapCrypto from './SwapCrypto';
import AdvanceTrading from './AdvanceTrading';
import GetStarted from './GetStarted';
import Testimonial from './Testimonial';
// import TestimonialSlider from './TestimonialSlider';

import BlogHighlights from './BlogHighlights';
import ContactSection from './ContactSection';


const Home = () => {
    return (
        <div>
            {/* <Intro  /> */}
            <Perfection />
            {/* <SwapCrypto /> */}
            <AdvanceTrading />
            {/* <GetStarted /> */}
            <Testimonial />
            {/* <TestimonialSlider /> */}

            <BlogHighlights />
            <ContactSection />
        </div>
    );
};

export default Home;
